/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AppRouteImport } from './routes/_app'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as FullRouteImport } from './routes/_full'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as AppPageRouteImport } from './routes/_app/$page'
import { Route as AppBarangaysRouteImport } from './routes/_app/barangays'
import { Route as AppCitiesRouteImport } from './routes/_app/cities'
import { Route as AppConfigurationRouteImport } from './routes/_app/configuration'
import { Route as AppEmployeeActivityLogRouteImport } from './routes/_app/employee-activity-log'
import { Route as AppEmployeesRouteImport } from './routes/_app/employees'
import { Route as AppMemberActivityLogRouteImport } from './routes/_app/member-activity-log'
import { Route as AppMemberAnalyticsRouteImport } from './routes/_app/member-analytics'
import { Route as AppMemberPopulationRouteImport } from './routes/_app/member-population'
import { Route as AppMembersRouteImport } from './routes/_app/members'
import { Route as AppNonMembersRouteImport } from './routes/_app/non-members'
import { Route as AppProfileRouteImport } from './routes/_app/profile'
import { Route as AppProvincesRouteImport } from './routes/_app/provinces'
import { Route as AppYellowPageRouteImport } from './routes/_app/yellow-page'
import { Route as AppYellowPageCategoriesRouteImport } from './routes/_app/yellow-page-categories'
import { Route as AuthLoginRouteImport } from './routes/_auth/login'
import { Route as AuthResetPasswordRequestRouteImport } from './routes/_auth/reset-password-request'
import { Route as AuthSetPasswordRouteImport } from './routes/_auth/set-password'
import { Route as FullChangePasswordRouteImport } from './routes/_full/change-password'
import { Route as AppMembersMemberIdRouteImport } from './routes/_app/members_.$memberId'
import { Route as AppProfilePasswordRouteImport } from './routes/_app/profile_.password'
import { Route as FullMembersNewRouteImport } from './routes/_full/members.new'

const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const FullRoute = FullRouteImport.update({
  id: '/_full',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const AppPageRoute = AppPageRouteImport.update({
  id: '/$page',
  path: '/$page',
  getParentRoute: () => AppRoute,
} as any)
const AppBarangaysRoute = AppBarangaysRouteImport.update({
  id: '/barangays',
  path: '/barangays',
  getParentRoute: () => AppRoute,
} as any)
const AppCitiesRoute = AppCitiesRouteImport.update({
  id: '/cities',
  path: '/cities',
  getParentRoute: () => AppRoute,
} as any)
const AppConfigurationRoute = AppConfigurationRouteImport.update({
  id: '/configuration',
  path: '/configuration',
  getParentRoute: () => AppRoute,
} as any)
const AppEmployeeActivityLogRoute = AppEmployeeActivityLogRouteImport.update({
  id: '/employee-activity-log',
  path: '/employee-activity-log',
  getParentRoute: () => AppRoute,
} as any)
const AppEmployeesRoute = AppEmployeesRouteImport.update({
  id: '/employees',
  path: '/employees',
  getParentRoute: () => AppRoute,
} as any)
const AppMemberActivityLogRoute = AppMemberActivityLogRouteImport.update({
  id: '/member-activity-log',
  path: '/member-activity-log',
  getParentRoute: () => AppRoute,
} as any)
const AppMemberAnalyticsRoute = AppMemberAnalyticsRouteImport.update({
  id: '/member-analytics',
  path: '/member-analytics',
  getParentRoute: () => AppRoute,
} as any)
const AppMemberPopulationRoute = AppMemberPopulationRouteImport.update({
  id: '/member-population',
  path: '/member-population',
  getParentRoute: () => AppRoute,
} as any)
const AppMembersRoute = AppMembersRouteImport.update({
  id: '/members',
  path: '/members',
  getParentRoute: () => AppRoute,
} as any)
const AppNonMembersRoute = AppNonMembersRouteImport.update({
  id: '/non-members',
  path: '/non-members',
  getParentRoute: () => AppRoute,
} as any)
const AppProfileRoute = AppProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => AppRoute,
} as any)
const AppProvincesRoute = AppProvincesRouteImport.update({
  id: '/provinces',
  path: '/provinces',
  getParentRoute: () => AppRoute,
} as any)
const AppYellowPageRoute = AppYellowPageRouteImport.update({
  id: '/yellow-page',
  path: '/yellow-page',
  getParentRoute: () => AppRoute,
} as any)
const AppYellowPageCategoriesRoute = AppYellowPageCategoriesRouteImport.update({
  id: '/yellow-page-categories',
  path: '/yellow-page-categories',
  getParentRoute: () => AppRoute,
} as any)
const AuthLoginRoute = AuthLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => AuthRoute,
} as any)
const AuthResetPasswordRequestRoute =
  AuthResetPasswordRequestRouteImport.update({
    id: '/reset-password-request',
    path: '/reset-password-request',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthSetPasswordRoute = AuthSetPasswordRouteImport.update({
  id: '/set-password',
  path: '/set-password',
  getParentRoute: () => AuthRoute,
} as any)
const FullChangePasswordRoute = FullChangePasswordRouteImport.update({
  id: '/change-password',
  path: '/change-password',
  getParentRoute: () => FullRoute,
} as any)
const AppMembersMemberIdRoute = AppMembersMemberIdRouteImport.update({
  id: '/members_/$memberId',
  path: '/members/$memberId',
  getParentRoute: () => AppRoute,
} as any)
const AppProfilePasswordRoute = AppProfilePasswordRouteImport.update({
  id: '/profile_/password',
  path: '/profile/password',
  getParentRoute: () => AppRoute,
} as any)
const FullMembersNewRoute = FullMembersNewRouteImport.update({
  id: '/members/new',
  path: '/members/new',
  getParentRoute: () => FullRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/$page': typeof AppPageRoute
  '/barangays': typeof AppBarangaysRoute
  '/cities': typeof AppCitiesRoute
  '/configuration': typeof AppConfigurationRoute
  '/employee-activity-log': typeof AppEmployeeActivityLogRoute
  '/employees': typeof AppEmployeesRoute
  '/member-activity-log': typeof AppMemberActivityLogRoute
  '/member-analytics': typeof AppMemberAnalyticsRoute
  '/member-population': typeof AppMemberPopulationRoute
  '/members': typeof AppMembersRoute
  '/non-members': typeof AppNonMembersRoute
  '/profile': typeof AppProfileRoute
  '/provinces': typeof AppProvincesRoute
  '/yellow-page': typeof AppYellowPageRoute
  '/yellow-page-categories': typeof AppYellowPageCategoriesRoute
  '/login': typeof AuthLoginRoute
  '/reset-password-request': typeof AuthResetPasswordRequestRoute
  '/set-password': typeof AuthSetPasswordRoute
  '/change-password': typeof FullChangePasswordRoute
  '/members/$memberId': typeof AppMembersMemberIdRoute
  '/profile/password': typeof AppProfilePasswordRoute
  '/members/new': typeof FullMembersNewRoute
}
export interface FileRoutesByTo {
  '/': typeof AppIndexRoute
  '/$page': typeof AppPageRoute
  '/barangays': typeof AppBarangaysRoute
  '/cities': typeof AppCitiesRoute
  '/configuration': typeof AppConfigurationRoute
  '/employee-activity-log': typeof AppEmployeeActivityLogRoute
  '/employees': typeof AppEmployeesRoute
  '/member-activity-log': typeof AppMemberActivityLogRoute
  '/member-analytics': typeof AppMemberAnalyticsRoute
  '/member-population': typeof AppMemberPopulationRoute
  '/members': typeof AppMembersRoute
  '/non-members': typeof AppNonMembersRoute
  '/profile': typeof AppProfileRoute
  '/provinces': typeof AppProvincesRoute
  '/yellow-page': typeof AppYellowPageRoute
  '/yellow-page-categories': typeof AppYellowPageCategoriesRoute
  '/login': typeof AuthLoginRoute
  '/reset-password-request': typeof AuthResetPasswordRequestRoute
  '/set-password': typeof AuthSetPasswordRoute
  '/change-password': typeof FullChangePasswordRoute
  '/members/$memberId': typeof AppMembersMemberIdRoute
  '/profile/password': typeof AppProfilePasswordRoute
  '/members/new': typeof FullMembersNewRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/_auth': typeof AuthRouteWithChildren
  '/_full': typeof FullRouteWithChildren
  '/_app/$page': typeof AppPageRoute
  '/_app/barangays': typeof AppBarangaysRoute
  '/_app/cities': typeof AppCitiesRoute
  '/_app/configuration': typeof AppConfigurationRoute
  '/_app/employee-activity-log': typeof AppEmployeeActivityLogRoute
  '/_app/employees': typeof AppEmployeesRoute
  '/_app/member-activity-log': typeof AppMemberActivityLogRoute
  '/_app/member-analytics': typeof AppMemberAnalyticsRoute
  '/_app/member-population': typeof AppMemberPopulationRoute
  '/_app/members': typeof AppMembersRoute
  '/_app/non-members': typeof AppNonMembersRoute
  '/_app/profile': typeof AppProfileRoute
  '/_app/provinces': typeof AppProvincesRoute
  '/_app/yellow-page': typeof AppYellowPageRoute
  '/_app/yellow-page-categories': typeof AppYellowPageCategoriesRoute
  '/_auth/login': typeof AuthLoginRoute
  '/_auth/reset-password-request': typeof AuthResetPasswordRequestRoute
  '/_auth/set-password': typeof AuthSetPasswordRoute
  '/_full/change-password': typeof FullChangePasswordRoute
  '/_app/': typeof AppIndexRoute
  '/_app/members_/$memberId': typeof AppMembersMemberIdRoute
  '/_app/profile_/password': typeof AppProfilePasswordRoute
  '/_full/members/new': typeof FullMembersNewRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/$page'
    | '/barangays'
    | '/cities'
    | '/configuration'
    | '/employee-activity-log'
    | '/employees'
    | '/member-activity-log'
    | '/member-analytics'
    | '/member-population'
    | '/members'
    | '/non-members'
    | '/profile'
    | '/provinces'
    | '/yellow-page'
    | '/yellow-page-categories'
    | '/login'
    | '/reset-password-request'
    | '/set-password'
    | '/change-password'
    | '/members/$memberId'
    | '/profile/password'
    | '/members/new'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/$page'
    | '/barangays'
    | '/cities'
    | '/configuration'
    | '/employee-activity-log'
    | '/employees'
    | '/member-activity-log'
    | '/member-analytics'
    | '/member-population'
    | '/members'
    | '/non-members'
    | '/profile'
    | '/provinces'
    | '/yellow-page'
    | '/yellow-page-categories'
    | '/login'
    | '/reset-password-request'
    | '/set-password'
    | '/change-password'
    | '/members/$memberId'
    | '/profile/password'
    | '/members/new'
  id:
    | '__root__'
    | '/_app'
    | '/_auth'
    | '/_full'
    | '/_app/$page'
    | '/_app/barangays'
    | '/_app/cities'
    | '/_app/configuration'
    | '/_app/employee-activity-log'
    | '/_app/employees'
    | '/_app/member-activity-log'
    | '/_app/member-analytics'
    | '/_app/member-population'
    | '/_app/members'
    | '/_app/non-members'
    | '/_app/profile'
    | '/_app/provinces'
    | '/_app/yellow-page'
    | '/_app/yellow-page-categories'
    | '/_auth/login'
    | '/_auth/reset-password-request'
    | '/_auth/set-password'
    | '/_full/change-password'
    | '/_app/'
    | '/_app/members_/$memberId'
    | '/_app/profile_/password'
    | '/_full/members/new'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  AuthRoute: typeof AuthRouteWithChildren
  FullRoute: typeof FullRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_full': {
      id: '/_full'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof FullRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/$page': {
      id: '/_app/$page'
      path: '/$page'
      fullPath: '/$page'
      preLoaderRoute: typeof AppPageRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/barangays': {
      id: '/_app/barangays'
      path: '/barangays'
      fullPath: '/barangays'
      preLoaderRoute: typeof AppBarangaysRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/cities': {
      id: '/_app/cities'
      path: '/cities'
      fullPath: '/cities'
      preLoaderRoute: typeof AppCitiesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/configuration': {
      id: '/_app/configuration'
      path: '/configuration'
      fullPath: '/configuration'
      preLoaderRoute: typeof AppConfigurationRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/employee-activity-log': {
      id: '/_app/employee-activity-log'
      path: '/employee-activity-log'
      fullPath: '/employee-activity-log'
      preLoaderRoute: typeof AppEmployeeActivityLogRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/employees': {
      id: '/_app/employees'
      path: '/employees'
      fullPath: '/employees'
      preLoaderRoute: typeof AppEmployeesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/member-activity-log': {
      id: '/_app/member-activity-log'
      path: '/member-activity-log'
      fullPath: '/member-activity-log'
      preLoaderRoute: typeof AppMemberActivityLogRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/member-analytics': {
      id: '/_app/member-analytics'
      path: '/member-analytics'
      fullPath: '/member-analytics'
      preLoaderRoute: typeof AppMemberAnalyticsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/member-population': {
      id: '/_app/member-population'
      path: '/member-population'
      fullPath: '/member-population'
      preLoaderRoute: typeof AppMemberPopulationRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/members': {
      id: '/_app/members'
      path: '/members'
      fullPath: '/members'
      preLoaderRoute: typeof AppMembersRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/non-members': {
      id: '/_app/non-members'
      path: '/non-members'
      fullPath: '/non-members'
      preLoaderRoute: typeof AppNonMembersRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/profile': {
      id: '/_app/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof AppProfileRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/provinces': {
      id: '/_app/provinces'
      path: '/provinces'
      fullPath: '/provinces'
      preLoaderRoute: typeof AppProvincesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/yellow-page': {
      id: '/_app/yellow-page'
      path: '/yellow-page'
      fullPath: '/yellow-page'
      preLoaderRoute: typeof AppYellowPageRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/yellow-page-categories': {
      id: '/_app/yellow-page-categories'
      path: '/yellow-page-categories'
      fullPath: '/yellow-page-categories'
      preLoaderRoute: typeof AppYellowPageCategoriesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_auth/login': {
      id: '/_auth/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof AuthLoginRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/reset-password-request': {
      id: '/_auth/reset-password-request'
      path: '/reset-password-request'
      fullPath: '/reset-password-request'
      preLoaderRoute: typeof AuthResetPasswordRequestRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/set-password': {
      id: '/_auth/set-password'
      path: '/set-password'
      fullPath: '/set-password'
      preLoaderRoute: typeof AuthSetPasswordRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_full/change-password': {
      id: '/_full/change-password'
      path: '/change-password'
      fullPath: '/change-password'
      preLoaderRoute: typeof FullChangePasswordRouteImport
      parentRoute: typeof FullRoute
    }
    '/_app/members_/$memberId': {
      id: '/_app/members_/$memberId'
      path: '/members/$memberId'
      fullPath: '/members/$memberId'
      preLoaderRoute: typeof AppMembersMemberIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/profile_/password': {
      id: '/_app/profile_/password'
      path: '/profile/password'
      fullPath: '/profile/password'
      preLoaderRoute: typeof AppProfilePasswordRouteImport
      parentRoute: typeof AppRoute
    }
    '/_full/members/new': {
      id: '/_full/members/new'
      path: '/members/new'
      fullPath: '/members/new'
      preLoaderRoute: typeof FullMembersNewRouteImport
      parentRoute: typeof FullRoute
    }
  }
}

interface AppRouteChildren {
  AppPageRoute: typeof AppPageRoute
  AppBarangaysRoute: typeof AppBarangaysRoute
  AppCitiesRoute: typeof AppCitiesRoute
  AppConfigurationRoute: typeof AppConfigurationRoute
  AppEmployeeActivityLogRoute: typeof AppEmployeeActivityLogRoute
  AppEmployeesRoute: typeof AppEmployeesRoute
  AppMemberActivityLogRoute: typeof AppMemberActivityLogRoute
  AppMemberAnalyticsRoute: typeof AppMemberAnalyticsRoute
  AppMemberPopulationRoute: typeof AppMemberPopulationRoute
  AppMembersRoute: typeof AppMembersRoute
  AppNonMembersRoute: typeof AppNonMembersRoute
  AppProfileRoute: typeof AppProfileRoute
  AppProvincesRoute: typeof AppProvincesRoute
  AppYellowPageRoute: typeof AppYellowPageRoute
  AppYellowPageCategoriesRoute: typeof AppYellowPageCategoriesRoute
  AppIndexRoute: typeof AppIndexRoute
  AppMembersMemberIdRoute: typeof AppMembersMemberIdRoute
  AppProfilePasswordRoute: typeof AppProfilePasswordRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppPageRoute: AppPageRoute,
  AppBarangaysRoute: AppBarangaysRoute,
  AppCitiesRoute: AppCitiesRoute,
  AppConfigurationRoute: AppConfigurationRoute,
  AppEmployeeActivityLogRoute: AppEmployeeActivityLogRoute,
  AppEmployeesRoute: AppEmployeesRoute,
  AppMemberActivityLogRoute: AppMemberActivityLogRoute,
  AppMemberAnalyticsRoute: AppMemberAnalyticsRoute,
  AppMemberPopulationRoute: AppMemberPopulationRoute,
  AppMembersRoute: AppMembersRoute,
  AppNonMembersRoute: AppNonMembersRoute,
  AppProfileRoute: AppProfileRoute,
  AppProvincesRoute: AppProvincesRoute,
  AppYellowPageRoute: AppYellowPageRoute,
  AppYellowPageCategoriesRoute: AppYellowPageCategoriesRoute,
  AppIndexRoute: AppIndexRoute,
  AppMembersMemberIdRoute: AppMembersMemberIdRoute,
  AppProfilePasswordRoute: AppProfilePasswordRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

interface AuthRouteChildren {
  AuthLoginRoute: typeof AuthLoginRoute
  AuthResetPasswordRequestRoute: typeof AuthResetPasswordRequestRoute
  AuthSetPasswordRoute: typeof AuthSetPasswordRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthLoginRoute: AuthLoginRoute,
  AuthResetPasswordRequestRoute: AuthResetPasswordRequestRoute,
  AuthSetPasswordRoute: AuthSetPasswordRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

interface FullRouteChildren {
  FullChangePasswordRoute: typeof FullChangePasswordRoute
  FullMembersNewRoute: typeof FullMembersNewRoute
}

const FullRouteChildren: FullRouteChildren = {
  FullChangePasswordRoute: FullChangePasswordRoute,
  FullMembersNewRoute: FullMembersNewRoute,
}

const FullRouteWithChildren = FullRoute._addFileChildren(FullRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  AuthRoute: AuthRouteWithChildren,
  FullRoute: FullRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
